// LIT workspace sidebar navigation

export const LitMonitoringNav = [
  {
    icon: "pe-7s-browser",
    label: "LIT Dashboard",
    to: "/lit/dashboard/home",
    permissionKey: "litDashboard",
  },
  {
    icon: "lnr-pilcrow",
    label: "Subscriber Analytics",
    to: "/lit/dashboard/india-map",
    permissionKey: "litTotalDevices",
  },
  // {
  //   icon: "pe-7s-appVersion",
  //   label: "App Version",
  //   to: "/lit/dashboard/app-version",
  //   permissionKey: "litAppVersion",
  // },
  {
    icon: "lnr-indent-increase",
    label: "Subscriber Profile",
    to: "/lit/subscriber",
    permissionKey: "litSubscriberProfile",
  },
  {
    icon: "lnr-calendar-full",
    label: "App Analytics",
    to: "/lit/events/totalEvents-GridView",
    permissionKey: "litEventsCaptured",
  },
  // {
  //   icon: "pe-7s-timer",
  //   label: "Control History",
  //   to: "/lit/control-history",
  // permissionKey: "litControlHistory",
  // },
];
